import { useCallback, useLayoutEffect, useRef } from 'react';
/**
 * Utility React hook that returns a function
 * to query whether or not this component has been
 * mounted and rendered in the DOM.
 */
export function useCheckIsMounted() {
    var isMountedRef = useRef(false);
    useLayoutEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    return useCallback(function () { return isMountedRef.current; }, []);
}
//# sourceMappingURL=useCheckIsMounted.js.map